export default __webpack_public_path__ + "static/Emerging-Technologies-b7baabcc8a28a535aefaad777e731fa6.webp";